<template>
  <IadWrapper inner-classes="flex flex-col gap-2xl">
    <IadTitle
      tag="h2"
      :text="$t(`agent.valuation.step.title`)"
      variant="large"
    />

    <ol class="flex flex-col lg:flex-row gap-xl">
      <li
        class="flex flex-col w-80 item-center text-center w-full"
      >
        <span
          class="flex justify-center items-center self-center bg-secondary-70 rounded-full size-28 font-semibold text-7xl"
          v-text="1"
        />

        <div class="px-l">
          <IadTitle
            class="pt-l pb-s"
            tag="p"
            :text="$t(`agent.valuation.step.first.title`)"
          />
          <p
            class="text-xl"
            v-text="$t(`agent.valuation.step.first.description`)"
          />
        </div>
      </li>
      <li
        class="flex flex-col w-80 item-center text-center w-full"
      >
        <span
          class="flex justify-center items-center self-center bg-secondary-70 rounded-full size-28 font-semibold text-7xl"
          v-text="2"
        />

        <div class="px-l">
          <IadTitle
            class="pt-l pb-s"
            tag="p"
            :text="$t(`agent.valuation.step.second.title`)"
          />
          <p
            class="text-xl"
            v-text="$t(`agent.valuation.step.second.description`)"
          />
        </div>
      </li>
      <li
        class="flex flex-col w-80 item-center text-center w-full"
      >
        <span
          class="flex justify-center items-center self-center bg-secondary-70 rounded-full size-28 font-semibold text-7xl"
          v-text="3"
        />

        <div class="px-l">
          <IadTitle
            class="pt-l pb-s"
            tag="p"
            :text="$t(`agent.valuation.step.third.title`)"
          />
          <p
            class="text-xl"
            v-text="$t(`agent.valuation.step.third.description`)"
          />
        </div>
      </li>
    </ol>
  </IadWrapper>
</template>
